import { Textarea } from "@mantine/core";
import { RiArrowRightUpLine } from "react-icons/ri";
import MemoryButton from "./MemoryButton";
import { textareaStyles } from "./memoryFieldStyles";
import css from "./memory.module.scss";

const MAX = 4000;

export default function MemoryEditor({
  isNew,
  text,
  busy,
  onChange,
  onSave,
  onCancel,
}) {
  return (
    <div className={css.shell}>
      <div className={`${css.core} ${css.editorCore}`}>
        <Textarea
          styles={textareaStyles}
          label={isNew ? "What should I remember?" : "Correct this fact"}
          value={text}
          onChange={(event) => onChange(event.currentTarget.value)}
          disabled={Boolean(busy)}
          autoFocus
          autosize
          minRows={3}
          maxLength={MAX}
        />
        <div className={css.editorActions}>
          <MemoryButton
            variant="primary"
            size="md"
            trailing={<RiArrowRightUpLine />}
            loading={busy === "save"}
            disabled={!text.trim() || (Boolean(busy) && busy !== "save")}
            onClick={onSave}
          >
            Save memory
          </MemoryButton>
          <MemoryButton disabled={Boolean(busy)} onClick={onCancel}>
            Cancel
          </MemoryButton>
          <span className={css.editorCount}>
            {text.length} / {MAX}
          </span>
        </div>
      </div>
    </div>
  );
}
